import React from "react";
import {ChatContainer} from "./app/component/chat/chat.container";

export default function App() {
    return <ChatContainer />
}